import { render, staticRenderFns } from "./Incubator.vue?vue&type=template&id=f9a9dd12"
import script from "./Incubator.vue?vue&type=script&lang=js"
export * from "./Incubator.vue?vue&type=script&lang=js"
import style0 from "./Incubator.vue?vue&type=style&index=0&id=f9a9dd12&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9a9dd12')) {
      api.createRecord('f9a9dd12', component.options)
    } else {
      api.reload('f9a9dd12', component.options)
    }
    module.hot.accept("./Incubator.vue?vue&type=template&id=f9a9dd12", function () {
      api.rerender('f9a9dd12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Incubator.vue"
export default component.exports